import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {BaseFancyTextCurveOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-fancy-text-curve-option';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';
import {MorphType} from '@Libraries/fancy-text-library';

interface FancyTextCurveSliderOptionProps {
  panelId: string;
  morphType: MorphType;
  morphAmount: number;
  onChangeShapeCurve(amount: number): void;
  onChangeShapeCurveEnded(amount: number): void;
  isDisabled?: boolean;
}

export function FancyTextCurveSliderOption({isDisabled = false, ...props}: FancyTextCurveSliderOptionProps): ReactElement | null {
  const isAvailable = (): boolean => {
    return props.morphType === MorphType.CURVE_UP || props.morphType === MorphType.CURVE_DOWN || props.morphType === MorphType.WAVE;
  };

  useEffect((): void => {
    updateOptionsPanelHeight(props.panelId, isAvailable() ? '236px' : '158px');
  }, [props.morphType]);

  if (!isAvailable()) {
    return null;
  }
  return (
    <div className="spacing-p-l-4 spacing-p-r-4 spacing-m-b-4">
      <BaseFancyTextCurveOption
        morphType={props.morphType}
        morphAmount={props.morphAmount}
        updateMorphAmount={(amount: number): void => {
          props.onChangeShapeCurve(amount);
        }}
        updateMorphAmountEnded={(amount: number): void => {
          props.onChangeShapeCurveEnded(amount);
        }}
        isSubOptionDisabled={isDisabled}
      />
    </div>
  );
}
